import React, { useState } from 'react';
import styled from 'styled-components';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { cadastrarCorretor } from './services/corretorService';

// ============ Estilos ============
const Page = styled.div`
  background: #0F1828;
  color: #F5F1E8;
  min-height: 100vh;
`;

const Hero = styled.section`
  padding: 140px 24px 80px;
  text-align: center;
  background:
    linear-gradient(180deg, rgba(15,24,40,.85), rgba(15,24,40,.95)),
    url('https://xtkorgedlxwfuaqyxguq.supabase.co/storage/v1/object/public/mf-imoveis/hero-bg.webp') center/cover;
  border-bottom: 1px solid rgba(184, 147, 90, .25);
`;

const HeroTitle = styled.h1`
  font-family: 'Cormorant Garamond', Georgia, serif;
  font-size: clamp(36px, 5vw, 56px);
  font-weight: 500;
  letter-spacing: 0.5px;
  max-width: 880px;
  margin: 0 auto 18px;
  line-height: 1.15;
`;

const HeroSubtitle = styled.p`
  font-size: clamp(15px, 1.4vw, 18px);
  color: rgba(245, 241, 232, 0.75);
  max-width: 640px;
  margin: 0 auto 36px;
  line-height: 1.6;
`;

const CtaBtn = styled.a`
  display: inline-block;
  padding: 16px 38px;
  background: #B8935A;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  text-decoration: none;
  border-radius: 4px;
  transition: transform .18s, box-shadow .18s;
  cursor: pointer;
  &:hover { transform: translateY(-2px); box-shadow: 0 12px 32px rgba(184, 147, 90, .35); }
`;

const Section = styled.section`
  padding: 96px 24px;
  max-width: 1100px;
  margin: 0 auto;
  &:nth-of-type(even) { background: rgba(255,255,255,.02); }
`;

const SectionTitle = styled.h2`
  font-family: 'Cormorant Garamond', Georgia, serif;
  font-size: clamp(28px, 3.5vw, 40px);
  text-align: center;
  margin: 0 0 14px;
  font-weight: 500;
`;

const SectionSubtitle = styled.p`
  text-align: center;
  font-size: 14px;
  color: rgba(245, 241, 232, 0.6);
  max-width: 560px;
  margin: 0 auto 56px;
  line-height: 1.6;
`;

const BenefitsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 32px;
`;

const BenefitCard = styled.div`
  padding: 36px 28px;
  background: rgba(255,255,255,.03);
  border: 1px solid rgba(184, 147, 90, .15);
  border-radius: 8px;
  transition: border-color .25s, transform .25s;
  &:hover { border-color: rgba(184, 147, 90, .45); transform: translateY(-4px); }
  h3 {
    font-family: 'Cormorant Garamond', Georgia, serif;
    font-size: 22px;
    font-weight: 500;
    margin: 0 0 14px;
    color: #D4A56A;
  }
  p { font-size: 14px; line-height: 1.65; color: rgba(245, 241, 232, .75); margin: 0; }
`;

const StepsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 28px;
`;

const Step = styled.div`
  text-align: center;
  .num {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 48px; height: 48px;
    border-radius: 50%;
    border: 1px solid rgba(184, 147, 90, .6);
    color: #D4A56A;
    font-family: 'Cormorant Garamond', Georgia, serif;
    font-size: 22px;
    margin: 0 auto 18px;
  }
  h4 { font-size: 15px; margin: 0 0 8px; font-weight: 600; }
  p { font-size: 13px; color: rgba(245, 241, 232, .6); line-height: 1.5; margin: 0; }
`;

// Form
const FormBox = styled.form`
  max-width: 720px;
  margin: 0 auto;
  padding: 48px 36px;
  background: rgba(255,255,255,.04);
  border: 1px solid rgba(184, 147, 90, .2);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

const FormRow = styled.div`
  display: grid;
  grid-template-columns: ${p => p.$cols || '1fr 1fr'};
  gap: 16px;
  @media (max-width: 640px) { grid-template-columns: 1fr; }
`;

const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 10px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: rgba(245, 241, 232, .55);
  font-weight: 600;
  input, select, textarea {
    background: rgba(15, 24, 40, .6);
    border: 1px solid rgba(184, 147, 90, .25);
    color: #F5F1E8;
    padding: 12px 14px;
    border-radius: 6px;
    font-size: 14px;
    font-family: inherit;
    letter-spacing: 0.2px;
    text-transform: none;
    font-weight: 400;
    outline: none;
    transition: border-color .15s;
    &:focus { border-color: #B8935A; }
    &:disabled { opacity: .5; cursor: not-allowed; }
  }
  textarea { resize: vertical; min-height: 80px; }
`;

const FileField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 18px;
  min-width: 0;
  overflow: hidden;
  border: 1px dashed ${p => p.$filled ? 'rgba(91, 176, 137, .55)' : 'rgba(184, 147, 90, .35)'};
  border-radius: 10px;
  background: ${p => p.$filled ? 'rgba(91, 176, 137, .04)' : 'rgba(15, 24, 40, .3)'};
  transition: border-color .2s, background .2s;
  &:hover { border-color: ${p => p.$filled ? 'rgba(91, 176, 137, .8)' : 'rgba(184, 147, 90, .55)'}; }
  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }
  label {
    font-size: 11px;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: rgba(245, 241, 232, .8);
    font-weight: 600;
  }
  .badge {
    font-size: 9px;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    padding: 3px 8px;
    border-radius: 999px;
    font-weight: 600;
    background: ${p => p.$required ? 'rgba(197, 84, 74, .15)' : 'rgba(184, 147, 90, .14)'};
    color: ${p => p.$required ? '#E18079' : 'rgba(184, 147, 90, .85)'};
    border: 1px solid ${p => p.$required ? 'rgba(197, 84, 74, .3)' : 'rgba(184, 147, 90, .3)'};
  }
  small {
    font-size: 11px;
    color: rgba(245, 241, 232, .45);
    line-height: 1.4;
  }
  .row {
    display: flex;
    gap: 12px;
    align-items: center;
  }
  input[type="file"] {
    font-size: 12px;
    color: rgba(245, 241, 232, .6);
    flex: 1;
    min-width: 0;
    &::file-selector-button {
      background: rgba(184, 147, 90, .15);
      color: #D4A56A;
      border: 1px solid rgba(184, 147, 90, .4);
      padding: 7px 14px;
      border-radius: 4px;
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 1px;
      text-transform: uppercase;
      cursor: pointer;
      margin-right: 12px;
      &:hover { background: rgba(184, 147, 90, .25); }
    }
  }
  .preview {
    width: 56px; height: 56px; border-radius: 6px;
    background-position: center;
    background-size: cover;
    border: 1px solid rgba(91, 176, 137, .4);
    flex-shrink: 0;
  }
`;

const SubmitBtn = styled.button`
  align-self: center;
  margin-top: 18px;
  padding: 15px 44px;
  background: #B8935A;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  cursor: pointer;
  transition: transform .15s, box-shadow .15s;
  &:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 8px 24px rgba(184, 147, 90, .3); }
  &:disabled { opacity: .5; cursor: not-allowed; }
`;

const DocsSectionTitle = styled.div`
  font-size: 11px;
  letter-spacing: 1.8px;
  text-transform: uppercase;
  color: rgba(245, 241, 232, .55);
  font-weight: 600;
  margin: 18px 0 -4px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(184, 147, 90, .1);
`;

const Msg = styled.div`
  padding: 14px 18px;
  border-radius: 6px;
  font-size: 13px;
  background: ${p => p.$ok ? 'rgba(91, 176, 137, .14)' : 'rgba(197, 84, 74, .14)'};
  color: ${p => p.$ok ? '#5BB089' : '#E18079'};
  border: 1px solid ${p => p.$ok ? 'rgba(91, 176, 137, .35)' : 'rgba(197, 84, 74, .35)'};
`;

const SuccessBox = styled.div`
  max-width: 620px;
  margin: 0 auto;
  padding: 56px 36px;
  text-align: center;
  background: rgba(91, 176, 137, .06);
  border: 1px solid rgba(91, 176, 137, .25);
  border-radius: 10px;
  h3 {
    font-family: 'Cormorant Garamond', Georgia, serif;
    font-size: 30px;
    margin: 0 0 14px;
    color: #5BB089;
    font-weight: 500;
  }
  p { font-size: 15px; line-height: 1.6; color: rgba(245, 241, 232, .8); margin: 0 0 10px; }
`;

const FaqItem = styled.details`
  border-bottom: 1px solid rgba(184, 147, 90, .12);
  padding: 18px 4px;
  cursor: pointer;
  summary {
    list-style: none;
    font-size: 15px;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &::-webkit-details-marker { display: none; }
    &::after { content: '+'; color: #B8935A; font-size: 22px; }
  }
  &[open] summary::after { content: '−'; }
  p { font-size: 14px; line-height: 1.6; color: rgba(245, 241, 232, .65); margin: 12px 0 0; }
`;

// ============ Component ============
const UFS = ['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'];

const initialForm = {
  nome: '', email: '', telefone: '', creci: '', creci_uf: 'SP', cidade: '', bio: '',
};
const initialDocs = { foto: null, creci_frente: null };

function FilePicker({ id, label, hint, value, onChange, required = false }) {
  const previewUrl = value ? URL.createObjectURL(value) : null;
  return (
    <FileField $required={required} $filled={!!value}>
      <div className="head">
        <label htmlFor={id}>{label}</label>
        <span className="badge">{required ? 'Obrigatório' : 'Opcional'}</span>
      </div>
      <small>{hint}</small>
      <div className="row">
        <input
          id={id}
          type="file"
          accept="image/*"
          onChange={(e) => onChange(e.target.files?.[0] || null)}
        />
        {previewUrl && <div className="preview" style={{ backgroundImage: `url(${previewUrl})` }} />}
      </div>
    </FileField>
  );
}

export default function SejaCorretorPage() {
  const [form, setForm] = useState(initialForm);
  const [docs, setDocs] = useState(initialDocs);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);
  const [success, setSuccess] = useState(false);

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));
  const setDoc = (k) => (file) => setDocs(d => ({ ...d, [k]: file }));

  const validate = () => {
    if (!form.nome.trim()) return 'Informe seu nome.';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) return 'Email inválido.';
    if (form.telefone.replace(/\D/g, '').length < 10) return 'Telefone inválido (com DDD).';
    if (!form.creci.trim()) return 'Informe seu CRECI.';
    if (!form.cidade.trim()) return 'Informe a cidade de atuação.';
    if (!docs.creci_frente) return 'Anexe a foto do CRECI (frente).';
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg(null);
    const err = validate();
    if (err) { setMsg({ ok: false, text: err }); return; }

    setBusy(true);
    try {
      await cadastrarCorretor(form, docs);
      setSuccess(true);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (e2) {
      console.error('[seja-corretor] cadastro falhou', e2);
      setMsg({ ok: false, text: 'Erro ao enviar cadastro. Tente novamente em instantes.' });
    } finally {
      setBusy(false);
    }
  };

  return (
    <Page>
      <Navbar />

      <Hero>
        <HeroTitle>Capte com a MF Real Estate</HeroTitle>
        <HeroSubtitle>
          Junte-se à rede de corretores parceiros e tenha seus imóveis publicados num
          portfólio especializado em Alphaville, Tamboré e Barueri.
        </HeroSubtitle>
        <CtaBtn href="#cadastro">Quero me cadastrar</CtaBtn>
      </Hero>

      <Section>
        <SectionTitle>Por que ser parceiro MF</SectionTitle>
        <SectionSubtitle>
          Um portfólio enxuto, curadoria de alto padrão, e visibilidade direcionada
          pra compradores qualificados da região.
        </SectionSubtitle>
        <BenefitsGrid>
          <BenefitCard>
            <h3>Visibilidade qualificada</h3>
            <p>
              Seus imóveis aparecem no site MF Real Estate, focado em Alphaville e
              entorno. Tráfego direcionado por SEO local e portais como ZAP/Viva Real.
            </p>
          </BenefitCard>
          <BenefitCard>
            <h3>Tecnologia integrada</h3>
            <p>
              Painel próprio pra cadastrar imóveis, fotos, descrição e acompanhar
              status. Marca d'água automática, geocodificação e SEO já prontos.
            </p>
          </BenefitCard>
          <BenefitCard>
            <h3>Comissão competitiva</h3>
            <p>
              Modelo de divisão claro, definido no cadastro e pago à parte de cada
              negócio fechado. Sem surpresas, sem letras miúdas.
            </p>
          </BenefitCard>
        </BenefitsGrid>
      </Section>

      <Section>
        <SectionTitle>Como funciona</SectionTitle>
        <SectionSubtitle>Quatro passos do cadastro à primeira comissão.</SectionSubtitle>
        <StepsRow>
          <Step>
            <div className="num">1</div>
            <h4>Cadastro</h4>
            <p>Preencha o formulário e anexe a frente do seu CRECI.</p>
          </Step>
          <Step>
            <div className="num">2</div>
            <h4>Aprovação</h4>
            <p>Nossa equipe revisa em até 3 dias úteis.</p>
          </Step>
          <Step>
            <div className="num">3</div>
            <h4>Publicação</h4>
            <p>Cadastre seus imóveis no painel exclusivo.</p>
          </Step>
          <Step>
            <div className="num">4</div>
            <h4>Comissão</h4>
            <p>Receba na venda ou locação fechada.</p>
          </Step>
        </StepsRow>
      </Section>

      <Section id="cadastro">
        <SectionTitle>Cadastro</SectionTitle>
        <SectionSubtitle>
          Preencha seus dados e anexe a frente do CRECI. Você receberá um email após a
          aprovação com link pra criar sua senha de acesso.
        </SectionSubtitle>

        {success ? (
          <SuccessBox>
            <h3>Cadastro recebido</h3>
            <p>
              Recebemos seus dados. Nossa equipe vai revisar e retornar
              em até 3 dias úteis com a resposta no email {form.email}.
            </p>
          </SuccessBox>
        ) : (
          <FormBox onSubmit={handleSubmit}>
            <FormRow>
              <Field>Nome completo
                <input type="text" value={form.nome} onChange={set('nome')} disabled={busy} required />
              </Field>
              <Field>Email
                <input type="email" value={form.email} onChange={set('email')} disabled={busy} required />
              </Field>
            </FormRow>

            <FormRow>
              <Field>Telefone (WhatsApp)
                <input type="tel" placeholder="(11) 9XXXX-XXXX" value={form.telefone} onChange={set('telefone')} disabled={busy} required />
              </Field>
              <Field>Cidade de atuação
                <input type="text" placeholder="Barueri, Santana de Parnaíba..." value={form.cidade} onChange={set('cidade')} disabled={busy} required />
              </Field>
            </FormRow>

            <FormRow $cols="2fr 1fr">
              <Field>CRECI
                <input type="text" placeholder="12345" value={form.creci} onChange={set('creci')} disabled={busy} required />
              </Field>
              <Field>UF do CRECI
                <select value={form.creci_uf} onChange={set('creci_uf')} disabled={busy}>
                  {UFS.map(uf => <option key={uf} value={uf}>{uf}</option>)}
                </select>
              </Field>
            </FormRow>

            <Field>Sobre você (opcional)
              <textarea
                placeholder="Conte brevemente sobre sua experiência, especialidades, anos de atuação..."
                value={form.bio}
                onChange={set('bio')}
                disabled={busy}
              />
            </Field>

            <DocsSectionTitle>Documentos</DocsSectionTitle>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 14 }}>
              <FilePicker
                id="doc-creci-frente"
                label="CRECI — frente"
                hint="Foto nítida da frente do CRECI com seus dados visíveis."
                value={docs.creci_frente}
                onChange={setDoc('creci_frente')}
                required
              />
              <FilePicker
                id="doc-foto"
                label="Foto de perfil"
                hint="Sua foto pro perfil no site após aprovação."
                value={docs.foto}
                onChange={setDoc('foto')}
              />
            </div>

            {msg && <Msg $ok={msg.ok}>{msg.text}</Msg>}

            <SubmitBtn type="submit" disabled={busy}>
              {busy ? 'Enviando...' : 'Enviar cadastro'}
            </SubmitBtn>
          </FormBox>
        )}
      </Section>

      <Section>
        <SectionTitle>Dúvidas frequentes</SectionTitle>
        <div style={{ maxWidth: 760, margin: '0 auto' }}>
          <FaqItem>
            <summary>Quanto custa pra ser parceiro?</summary>
            <p>Nada. Você só paga a comissão acordada quando fechar negócio através da plataforma.</p>
          </FaqItem>
          <FaqItem>
            <summary>Posso cadastrar imóveis de outras imobiliárias?</summary>
            <p>Não. Você só pode cadastrar imóveis onde tenha autorização do proprietário ou exclusividade de captação.</p>
          </FaqItem>
          <FaqItem>
            <summary>Quanto tempo leva pra aprovação?</summary>
            <p>Em geral até 3 dias úteis. Casos com documentos pendentes podem demorar mais.</p>
          </FaqItem>
          <FaqItem>
            <summary>Como recebo a comissão?</summary>
            <p>A divisão é feita após o fechamento do negócio, conforme o percentual acordado no seu cadastro. Pagamento via Pix ou transferência.</p>
          </FaqItem>
          <FaqItem>
            <summary>Posso me descadastrar depois?</summary>
            <p>Sim, a qualquer momento. Seus imóveis em negociação ativa permanecem até serem finalizados.</p>
          </FaqItem>
        </div>
      </Section>

      <Footer />
    </Page>
  );
}
